import { ReactElement, ReactNode } from 'react';
import { CSSObject, FormHelperText, Grid, Stack, Typography } from '@mui/material';
import { IComponentCss } from '../styles';

/*
*   Блок - обертка для поля
*/

export enum FieldWrapVariant {
    TwoColumn = 'twoColumn',
    SingleColumn = 'singleColumn',
}

export enum FieldWrapLabelPosition {
    Center = 'center',
    Top = 'top',
}

type FieldWrapProps = {
    label?: string,
    isRequired?: boolean,
    children?: ReactNode | ReactElement<any, any>,
    wrapStyle?: CSSObject,
    wrapLabelStyle?: CSSObject,
    errorMessage?: string,
    helpMessage?: string,
    exampleText?: string,
    size?: FieldSize,
    variant?: FieldWrapVariant,
    labelPosition?: FieldWrapLabelPosition,
}

// TODO: Наверное, лучше перенести в тему
export enum FieldSize {
    Short = 'short',
    Compact = 'compact',
    Medium = 'medium',
    Long = 'long',
    Full = 'full',
    Custom = 'custom',
    Default = 'default',
}

// TODO: Наверное, лучше перенести в тему
const sizesCss: { [key in FieldSize]: CSSObject } = {
    [FieldSize.Short]: {
        '& .MuiInputBase-root': {
            width: '100px',
        },
    },
    [FieldSize.Compact]: {
        '& .MuiInputBase-root': {
            width: '150px',
        },
    },
    [FieldSize.Medium]: {
        '& .MuiInputBase-root': {
            width: '300px',
        },
    },
    [FieldSize.Long]: {
        '& .MuiInputBase-root': {
            width: '510px',
        },
    },
    [FieldSize.Full]: {
        '& .MuiInputBase-root': {
            width: '100%',
        },
        '& .MuiFormControl-root': {
            width: '100%',
        },
    },
    [FieldSize.Custom]: {},
    [FieldSize.Default]: {},
}

const css: IComponentCss = {
    rootStack: {
        width: '100%',
        marginBottom: '4px',
        [`&.${FieldWrapVariant.TwoColumn}`]: {

        },
        [`&.${FieldWrapVariant.SingleColumn}`]: {

        },
    },
    wrap: {
        //TODO: проверить как использовалось и убрать это. Скорее всего это было нужно в заявках.
        [`& .field-${FieldSize.Full}`]: {
            width: '100%',
        },
        [`& .field-${FieldSize.Short}`]: {
            width: '100px',
        },
        [`& .field-${FieldSize.Medium}`]: {
            width: '300px',
        },
        [`& .field-${FieldSize.Long}`]: {
            width: '510px',
        },
        flexWrap: 'nowrap',
    },
    labelWrap: {
        width: '130px',
        minWidth: '130px',
        display: 'flex',
        paddingRight: '16px',
    },
    label: {
        textAlign: 'right',
        color: '#999999',
        padding: 0,
    },
    childrenWrap: {
        display: 'flex',
        flex: 1,
        alignItems: 'center',
    },
    requiredStar: {
        color: '#de350b',
    },
    exampleText: {
        fontSize: '14px',
        marginLeft: '8px',
    },
}

export function FieldWrap({
    label,
    isRequired = false,
    children,
    wrapStyle = {},
    wrapLabelStyle = {},
    errorMessage,
    helpMessage,
    exampleText,
    size = FieldSize.Default,
    variant = FieldWrapVariant.TwoColumn,
    labelPosition = FieldWrapLabelPosition.Center,
}: FieldWrapProps) {

    return (
        <Stack className={variant} sx={css.rootStack}>
            <Grid
                container
                sx={{ ...css.wrap, ...sizesCss[size], ...wrapStyle }}
            >
                {variant === FieldWrapVariant.TwoColumn && (
                    <Grid
                        item
                        sx={{ ...css.labelWrap, ...wrapLabelStyle }}
                        justifyContent='flex-end'
                        alignItems={labelPosition === FieldWrapLabelPosition.Center ? 'center' : 'self-start'}
                    >
                        <Typography sx={css.label}>
                            {label ?? ''}
                            <Typography component='span' sx={{ ...css.requiredStar, opacity: isRequired ? 1 : 0 }}>*</Typography>
                        </Typography>
                    </Grid>
                )}
                <Grid
                    item
                    sx={{
                        ...css.childrenWrap,
                    }}
                >
                    {children}
                    {Boolean(exampleText) && (
                        <FormHelperText component={'span'} sx={css.exampleText}>{exampleText}</FormHelperText>
                    )}
                </Grid>
            </Grid>
            <Grid
                container
                sx={{ ...css.wrap, ...sizesCss[size], ...wrapStyle }}
            >
                {variant === FieldWrapVariant.TwoColumn && (
                    <Grid
                        item
                        sx={{ ...css.labelWrap, ...wrapLabelStyle }}
                    >
                    </Grid>
                )}
                <Stack>
                    {Boolean(helpMessage) && (
                        <FormHelperText>{helpMessage}</FormHelperText>
                    )}
                    <FormHelperText error={Boolean(errorMessage)}>{errorMessage ?? ' '}</FormHelperText>
                </Stack>
            </Grid>
        </Stack>

    );
}
